module.exports = __webpack_public_path__ + "static/wood-style-2-02464a71c93b4ed6a6ed1ed056c18481.png";